var Getter = require('./getter');

module.exports = Element;

function Element () {}
Element.prototype = new Getter();
Element.prototype.constructor = Element;

Element.prototype.initialize = function () {
  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;

  this.structure = {
    'id': null,
    'z_index': null,
    'position': { 'x': null, 'y': null },
    'rotation': null,
    'size': { 'width': null, 'height': null },
    'opacity': null,
    'locked': null
  };
};

Element.prototype.getId = function () {
  return this.element.getAttribute('id') || assignUniqueId.call(this);

  function assignUniqueId () {
    var id;
    var editor = this.editor || INKIVE.Tool.getInstance().editor;

    do { id = editor.getNextId(); }
    while ($('#' + id).length);

    this.element.setAttribute('id', id);

    return id;
  }
};

Element.prototype.getRotation = function () {
  return this.canvas.getRotationAngle(this.element);
};

Element.prototype.getOpacity = function () {
  var opacity = parseFloat(this.element.getAttribute('opacity'));
  return _.isNaN(opacity) ? 1 : opacity;
};

Element.prototype.getPositionX = function () {
  try {
    this.bb = this.bb || this.element.getBBox();
  } catch (e) {}
  return this.bb ? this.bb.x : 0;
};

Element.prototype.getPositionY = function () {
  try {
    this.bb = this.bb || this.element.getBBox();
  } catch (e) {}
  return this.bb ? this.bb.y : 0;
};

Element.prototype.getSizeWidth = function () {
  try {
    this.bb = this.bb || this.element.getBBox();
  } catch (e) {}
  return this.bb ? this.bb.width : 0;
};

Element.prototype.getSizeHeight = function () {
  try {
    this.bb = this.bb || this.element.getBBox();
  } catch (e) {}
  return this.bb ? this.bb.height : 0;
};

Element.prototype.getLocked = function () {
  return $(this.element).hasClass('locked');
};
